import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { API_ACTION, API_SCOPE, ApiAction, ApiScope } from 'src/app/shared/interceptor/interceptor.token';
import { BillingApiResponse } from 'src/app/shared/interface/billing.interface';
import { CommonApiResponse } from 'src/app/shared/interface/common.interface';
import { environment as ENV } from 'src/environments/environment';

/** Calls against the Profet Portal backend, which owns the signed in user's profile and billing. */
@Injectable({
  providedIn: 'root',
})
export class ProfetPortalApi {
  constructor(private _http: HttpClient) {}

  /** Check whether the company's billing setup allows an order of the given report type. */
  checkBillingEligibility(reportType: string): Observable<CommonApiResponse<BillingApiResponse>> {
    return this._http
      .get<CommonApiResponse<BillingApiResponse>>(`${ENV.portal.backendBaseUrl}/api/billing/checkBillingEligibility`, {
        params: { appId: 'profet-valuation', orderType: reportType },
        context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.COMPANY),
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const fallbackResponse: CommonApiResponse<BillingApiResponse> = {
            status: 'FAILED',
            httpCode: error.status,
            type: error.error?.type ?? 'UNKNOWN_ERROR',
            message: error.error?.message ?? 'Something went wrong',
            data: error.error?.data ?? ({} as BillingApiResponse),
          };
          return of(fallbackResponse);
        })
      );
  }

  /**
   * Save a signature image on the signed in user's Profet Portal profile.
   * The Content-Type header is deliberately left unset so the browser adds the multipart boundary.
   */
  updateSignature(formData: FormData): Observable<CommonApiResponse> {
    return this._http.post<CommonApiResponse>(`${ENV.portal.backendBaseUrl}/api/profile/updateSignature`, formData, {
      context: new HttpContext().set(API_ACTION, ApiAction.WRITE).set(API_SCOPE, ApiScope.USER),
    });
  }
}
